import { belowConfigStrip } from './below-config-strip';

export const esprit = {
  belowConfigStrip,
};
